import React, { useEffect, useState } from "react";
import {
  useLocation,
  Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MuiTelInput } from "mui-tel-input";
import { registrationSchema } from "../../utils/validationSchema";
import useAuth from "../../hooks/useAuth";
import { defaultValues } from "../../utils/constant";
import PasswordFields from "../../components/UI/PasswordFields";
import useDashboard from "../../hooks/useDashboard";
import { CallAPI } from "../../utils/apiActions";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Swal from "sweetalert2";

export const cleanNumber = (value) => {
  return value.replace(/\s/g, "");
};

const SignUpForm = ({ ...props }) => {
  const navigate = useNavigate();
  let location = useLocation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;
  const referral = searchParams.get("referral") || null;
  const inviteID = searchParams.get("inviteID") || null;

  const planId = searchParams.get("plan_id");
  const [currentPlan, setCurrentPlan] = useState(undefined);

  const { loader, register, companyInfo } = useAuth();
  const { checkPromocode } = useDashboard();
  const [registrationErr, setRegistrationErr] = useState(undefined);

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registrationSchema),
    defaultValues: defaultValues,
  });

  function returnRest(data) {
    const { confirmPassword, ...rest } = data;
    return rest;
  }

  const onSubmit = async (data) => {
    if (!executeRecaptcha) return;

    const token = await executeRecaptcha("signup_form");

    if (!token) {
      Swal.fire("", "Please accept reCAPTCHA", "info");

      return;
    }

    await CallAPI(
      "USER",
      "POST",
      "users/verify-recaptcha",
      { recaptchaToken: token },
      false,
      false,
    );

    let la_data = { ...data };
    delete la_data.isAgree;
    props.setRegisterData(la_data);
    setRegistrationErr(undefined);

    if (la_data.promoCode) {
      const checkPromo = await checkPromocode({
        promoCode: la_data.promoCode,
      });
      // if(checkPromo?.la_data){
      //   showToast("Promocode Applied Success", LABEL.TOAST_TYPE.SUCCESS);
      // }
      if (!checkPromo.success) {
        return;
      }
    }

    if (location.pathname.includes("affiliate")) {
      la_data.userType = 5;
    }

    if (!!parentAgency) {
      la_data.userType = 3;
      la_data.parentId = parentAgency;
    }

    if (!!referral) {
      la_data.referral = referral;
      if (!!inviteID) la_data.inviteID = inviteID;
    }
    // if (!currentPlan) return;
    let response = await register(
      returnRest({
        ...la_data,
        ...(currentPlan && { selectedPlan: currentPlan }),
      }),
    );

    // console.log(response);
    if (!response?.success) {
      setRegistrationErr(response?.msg ?? "Server error");
    } else {
      setRegistrationErr(undefined);
      if (window.gtag) {
        console.log(data, "data");
        window.gtag("event", "sign_up", {
          method: "email",
          email: data.email,
          phone_number: data.phoneNumber,
        });
      }
    }
  };

  const getFreePlan = async (country = "India") => {
    const servicePath =
      country === "India" ? "SUBSCRIPTION_IN" : "SUBSCRIPTION_OTHERS";
    const response = await CallAPI(
      servicePath,
      "POST",
      "subscription/user-plan-list",
      country === "India" ? { country: "India" } : { country: "Other" },
    );

    if (response?.res?.status === 200) {
      if (Array.isArray(response?.res?.data?.data?.plan_list)) {
        const freePlan = response.res.data.data.plan_list.find(
          (t) => t.isFreePlan === 1,
        );
        setCurrentPlan(freePlan);
      }
    }
  };

  const getPlanDetails = async (p) => {
    try {
      const response = await CallAPI(
        "SUBSCRIPTION",
        "GET",
        "subscription/get-plan/" + p,
      );
      setCurrentPlan(response?.res?.data?.data);
    } catch (error) {
      navigate("/pricing");
    }
  };

  useEffect(() => {
    if (planId) {
      getPlanDetails(planId);
    } else {
      getFreePlan();
    }
  }, [planId]);

  return (
    <div className="form-grid_left">
      <div className="form-grid_gredient">
        <div className="form-grid_block">
          <figure>
            <Link to="/">
              <img
                src={
                  !!parentAgency ? companyInfo?.logo : "/images/bottbuddy.png"
                }
                alt
              />
            </Link>
          </figure>

          <div className="loginForm">
            <header>
              <h4>Create your account</h4>
              <p>Please create your account to continue</p>
            </header>
            <form
              id
              method="get"
              action
              role="form"
              onSubmit={handleSubmit(onSubmit)}
              autoComplete="off"
            >
              <div className="row">
                <div className="col-xl-12">
                  <div className="field">
                    <label for="txtName">
                      First Name<strong style={{ color: "red" }}> *</strong>
                    </label>

                    <Controller
                      name="firstName"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className={`form-control ${
                            errors.firstName ? "is-invalid" : ""
                          }`}
                          id="txtName"
                          placeholder="Enter Your First Name"
                        />
                      )}
                    />

                    {errors.firstName && <p>{errors.firstName.message}</p>}
                  </div>

                  <div className="field">
                    <label for="txtName">
                      Last Name<strong style={{ color: "red" }}> *</strong>
                    </label>

                    <Controller
                      name="lastName"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className={`form-control ${
                            errors.lastName ? "is-invalid" : ""
                          }`}
                          id="txtName"
                          placeholder="Enter Your Last Name"
                        />
                      )}
                    />

                    {errors.lastName && <p>{errors.lastName.message}</p>}
                  </div>

                  <div className="field">
                    <label for="txtEmail">
                      Email<strong style={{ color: "red" }}> *</strong>
                    </label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          id="txtEmail"
                          name="txtEmail"
                          placeholder="Enter Your Email"
                          autoComplete="off"
                        />
                      )}
                    />
                    {errors.email && <p>{errors.email.message}</p>}
                  </div>
                  <div className="field">
                    <label for="txtPhoneNumber">Phone Number</label>

                    <Controller
                      name="phoneNumber"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <MuiTelInput
                          {...field}
                          onChange={(value, info) => {
                            field.onChange(cleanNumber(value));
                          }}
                          id="full-width-text-field-mobile"
                          fullWidth={true}
                          variant="outlined"
                          forceCallingCode
                          enableLongNumbers={true}
                          autoFormat={false}
                          disableAreaCodes={true}
                          countryCodeEditable={false}
                          autoComplete="off"
                          className="customtel"
                          placeholder="Enter Your Phone Number"
                          defaultCountry="IN"
                        />
                      )}
                    />
                    {errors.phoneNumber && <p>{errors.phoneNumber.message}</p>}
                  </div>
                  <div className="field">
                    <label for="txtPassword">
                      Password<strong style={{ color: "red" }}> *</strong>
                    </label>
                    <PasswordFields
                      id="txtPassword"
                      name="password"
                      control={control}
                      errors={errors}
                      placeholder="Enter Your Password"
                    />
                  </div>
                  <div className="field">
                    <label for="txtConfirmPassword">
                      Confirm Password
                      <strong style={{ color: "red" }}> *</strong>
                    </label>
                    <PasswordFields
                      id="txtConfirmPassword"
                      name="confirmPassword"
                      control={control}
                      errors={errors}
                      placeholder="Confirm Your Password"
                    />
                  </div>

                  {!location.pathname.includes("affiliate") && (
                    <div className="field">
                      <label for="txtOrganizationName">Organization Name</label>

                      <Controller
                        name="organizationName"
                        control={control}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            id="txtOrganizationName"
                            placeholder="Enter organization name"
                          />
                        )}
                      />

                      {errors.organizationName && (
                        <p>{errors.organizationName.message}</p>
                      )}
                    </div>
                  )}

                  {!location.pathname.includes("affiliate") && (
                    <div className="field">
                      <label for="txtBusinessURL">Business URL</label>

                      <Controller
                        name="businessUrl"
                        control={control}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            id="txtBusinessURL"
                            placeholder="Enter Business URL"
                          />
                        )}
                      />

                      {errors.businessUrl && (
                        <p>{errors.businessUrl.message}</p>
                      )}
                    </div>
                  )}

                  {/* {!location.pathname.includes("affiliate") && (
                    <div className="field">
                      <label for="txtPromoCode">Promo code</label>

                      <Controller
                        name="promoCode"
                        control={control}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            id="txtPromoCode"
                            placeholder="Enter Promo code"
                          />
                        )}
                      />

                      {errors.promoCode && <p>{errors.promoCode.message}</p>}
                    </div>
                  )} */}
                </div>

                <div className="form-check form-check-tick mb--10">
                  <Controller
                    name="isAgree"
                    control={control}
                    render={({ field }) => (
                      <label
                        className={`checkbox-label ${
                          errors.isAgree ? "is-invalid" : ""
                        }`}
                      >
                        <input
                          className="checkbox"
                          type="checkbox"
                          {...field}
                          checked={field.value} // Ensure it's controlled
                        />
                        <span className="tick-icon"></span>I Agree
                        <strong style={{ color: "red" }}> *</strong>
                      </label>
                    )}
                  />
                  {errors.isAgree && (
                    <p style={{ color: "red" }}>{errors.isAgree.message}</p>
                  )}
                </div>
                {/*<div className="form-check mb--10">
                  <Controller
                    name="isAgree"
                    control={control}
                    render={({ field }) => (
                      <div>
                        <input
                          type="checkbox"
                          {...field}
                          checked={field.value} // Ensure it's controlled
                        />
                      </label>
                    )}
                  />
                  I Agree
                </div>*/}

                <div className="field mb-2">
                  <small>
                    By checking this box, I accept{" "}
                    {!!parentAgency ? companyInfo?.orgName : "BottBuddy"}'s{" "}
                    <a
                      href="/terms-of-service"
                      target="_blank"
                      style={{
                        textDecoration: "underline",
                        color: "lightblue",
                      }}
                    >
                      Terms of Services{" "}
                    </a>
                    and{" "}
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      style={{
                        textDecoration: "underline",
                        color: "lightblue",
                      }}
                    >
                      Privacy Policy
                    </a>
                    , and consent to receive text and emails for communication
                    and promotions.I understand that I can opt-out and request
                    account deletion at any time.
                  </small>
                </div>
                {/* {errors.isAgree && (
                  <p className="errorMessage mt-0">{errors.isAgree.message}</p>
                )} */}

                <div className="col-12 text-center mb--20">
                  {registrationErr ? (
                    <h5 style={{ color: "red", fontWeight: "bold" }}>
                      {registrationErr}
                    </h5>
                  ) : null}
                </div>
                <div className="col-12 text-center mb--20">
                  <button
                    type="submit"
                    disabled={!!loader}
                    className="cta-green"
                    id="loginFormSubmit"
                  >
                    {!!loader && (
                      <i className="fa-solid fa-spinner fa-spin"></i>
                    )}
                    Create Account
                  </button>
                </div>
                {/* <div className="col-12 text-center">
                          <div className="or-devider">
                            <span>or</span>
                          </div>
                        </div>
                        <div className="login-with-social">
                          <a href="#" className="cta-border">
                            <img
                              src="/images/icons/google-icon.png"
                              alt="icon"
                            />
                            Google
                          </a>
                          <a href="#" className="cta-border">
                            <img
                              src="/images/icons/facebook-icon.png"
                              alt="icon"
                            />
                            Facebook
                          </a>
                        </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpForm;
